/**
 * Collaboration Formly Setup
 *
 * Registers the lockable-field wrapper for real-time collaboration on
 * the instructor course-edit surfaces. `forChild` (not `forRoot`) so it
 * cleanly composes with the eager `FormlyCoreSetup` at the root of the
 * app — pre-P0-3 this was `forRoot`, but two `forRoot` registrations is
 * an anti-pattern; the lazy routes that need lockable fields apply this
 * setup via `importProvidersFrom`.
 */
import { FormlyModule } from '@ngx-formly/core';
import { LockableFieldWrapper } from './lockable-field.wrapper';

export const CollaborationFormlySetup = FormlyModule.forChild({
  wrappers: [{ name: 'lockable-field', component: LockableFieldWrapper }],
});

export const CollaborationFormlyComponents = [LockableFieldWrapper];
